module.exports = __webpack_public_path__ + "static/img/banner_03.2ddbc1c.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/img/banner_03.jpg
// module id = 2gso
// module chunks = 1